import { ChangeEvent, EventHandler, KeyboardEvent, useState, useEffect } from 'react'
import { isEqual } from 'lodash'

type UseSearchFilterProps = {
  queryParams: {
    query?: string
  }
  setQueryParams: (params: { query?: string }) => void
}

export const useSearchFilter = ({ queryParams, setQueryParams }: UseSearchFilterProps) => {
  const [searchValue, setSearchValue] = useState<string>(queryParams?.query ?? '')

  useEffect(() => {
    if (!isEqual(queryParams?.query, searchValue)) {
      setSearchValue(queryParams?.query ?? '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams?.query])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value)
  }

  const handleKeyPress: EventHandler<KeyboardEvent<HTMLInputElement>> = event => {
    if (searchValue.length <= 255) {
      if (event.key === 'Enter') {
        const trimmedValue = (event.target as HTMLInputElement).value.trim()
        setQueryParams?.({
          query: trimmedValue || undefined
        })
      }
    }

    if (event.key === 'Escape') {
      setQueryParams?.({
        query: undefined
      })

      setSearchValue('')
    }
  }

  const handleClearValue = () => {
    setSearchValue('')
    setQueryParams?.({
      query: undefined
    })
  }

  return {
    searchValue,
    handleChange,
    handleKeyPress,
    handleClearValue
  }
}
